module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isError) ? _c('div', {
    staticClass: "success"
  }, [_c('div', {
    staticClass: "success__pic"
  }), _c('div', {
    staticClass: "success__block"
  }, [_c('AppHeading', {
    attrs: {
      "level": "3"
    }
  }, [_vm._v("Спасибо, что откликнулись на вакансию. Ваш отклик  будет обработан в ближайшее время. На вашу электронную почту будет направлено письмо от организации-работодателя. Уточнить статус отклика вы сможете в своем личном кабинете.")]), _c('Button', {
    attrs: {
      "size": "normal",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('understood')
      }
    }
  }, [_vm._v("Да, понятно")])], 1)]) : _c('div', {
    staticClass: "error"
  }, [_c('AppHeading', {
    attrs: {
      "level": "2",
      "mod": "red, center"
    }
  }, [_vm._v(_vm._s(_vm.errorText))]), _c('Button', {
    attrs: {
      "size": "normal",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('understood')
      }
    }
  }, [_vm._v("Закрыть")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24c16946","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vacancies/form/components/successmewssage/SuccessMessage.vue
// module id = 367470110b737426ad4c
// module chunks = 13